<span class="races-info padding col-12">
  <span class="name">{{ selectedRace.name }}</span>
  <span class="material-icons">date_range</span>
  <span class="date">{{ selectedRace.date | date: "dd.MM.yyyy" }}</span>
  <span class="material-icons">room</span>
  <span class="city">{{ selectedRace.city.address }}</span>
</span>
